export const objectIsEmpty = (object) => Object.keys(object).length === 0
export const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
